///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Toolbar Module
//
///////////////////////////////////////////////////////////////////////////////////////////////////

import $ from 'jquery';

const toolbar = {
    // Build the mobile menu dynamically
    async register() {
        $(() => {
            toolbar.init();
        });
    },

    init: function() {
        $('#main-toolbar li.dyna-link').remove();

        /*
        <li class="nav-item" :class="{ 'active': route == 'members' }">
            <router-link to="/" class="nav-link">Home</router-link>
        </li>
        */

       /*
        $('#main-sidebar a').each(function() {
            var title = $(this).attr('title') || $(this).data('original-title');
            var route = (window.location.pathname == '/members') ? '/' : window.location.pathname;
            var active = (route == $(this).attr('href')) ? 'active' : '';

            var link = '<li class="nav-item dyna-link d-block d-lg-none ' + active + '"><a href="' + $(this).attr('href') + '" data-toggle="' + $(this).data('toggle') + '" class="nav-link">' + title + '</a></li>';

            $('#main-toolbar').append(link);
        });
        */
    },
};

export default toolbar;
